import { proxy } from 'valtio';
import {
  clearTeamState,
  resolveAiWatermarkValueFromPayload,
  syncAiWatermarkPreference,
} from '@/entities/team';
import {
  resolveAuthMode,
  type AuthApiLoginData,
  type AuthMode,
} from './auth-session';
import {
  clearStoredSession,
  getOrCreateVisitorId,
  readStoredSession,
  writeStoredSession,
} from './auth-storage';

export interface AuthState {
  mode: AuthMode;
  visitorId: string;
  loginData: AuthApiLoginData | null;
  initialized: boolean;
}

export const authStore = proxy<AuthState>({
  mode: 'unknown',
  visitorId: '',
  loginData: null,
  initialized: false,
});

/**
 * 从 localStorage 读取已有会话填充 store。
 * 在 app 启动时调用一次。
 */
export function hydrateAuthFromStorage() {
  const visitorId = getOrCreateVisitorId();
  const loginData = readStoredSession();
  authStore.visitorId = visitorId;
  authStore.loginData = loginData;
  authStore.mode = resolveAuthMode(loginData);
  authStore.initialized = true;

  const userKey =
    loginData?.user_info?.uuid ||
    loginData?.user_info?.account ||
    loginData?.user_info?.token ||
    ''

  if (userKey) {
    syncAiWatermarkPreference({
      userKey,
      teamId: loginData?.current_team?.team_id || loginData?.user_info?.team_id || '',
      aiWatermark:
        resolveAiWatermarkValueFromPayload(loginData?.current_team) ??
        resolveAiWatermarkValueFromPayload(loginData?.user_info) ??
        null,
    })
  }
}

export function applyAuthSession(loginData: AuthApiLoginData) {
  writeStoredSession(loginData);
  authStore.loginData = loginData;
  authStore.mode = resolveAuthMode(loginData);
  authStore.initialized = true;
}

export function clearAuthSession(nextMode: AuthMode = 'unknown') {
  clearStoredSession();
  clearTeamState();
  authStore.visitorId = authStore.visitorId || getOrCreateVisitorId();
  authStore.loginData = null;
  authStore.mode = nextMode;
  authStore.initialized = true;
}
